import {
  put,
  fork,
  call,
  take,
  takeEvery,
  takeLatest,
  all,
  select,
} from 'redux-saga/effects';
import app from '../../app';
import { weibanPhonesCompletion, weibanOrderCompletion, weibanOrderDetailCompletion, weibanStoreOrderCompletion } from '../../actions';

const weibanhost = process.env.REACT_APP_WEIBAN
export function* weibanphonePost() {
  yield takeEvery('WEIBAN_PHONE', function* (data) {
    const options = {
      url: `${weibanhost}/api/sidebar/updatePhone`,
      data: data,
      method: 'GET'
    };
    const result = yield call(app.httpFetch, options);
    if (result.data) {
      app.showTips('succ', '查询成功');
    }
    yield put(weibanPhonesCompletion(result.error, result.data));
  });
}
export function* weibanOrderGet() {
  yield takeEvery('WEIBAN_ORDER', function* ({ willReload }) {
    const tte = yield select(state => state.weiban.weiban);
    const { list, query } = yield select(state => state.weiban.weiban);
    console.log(tte.list);
    const tabDict = { store: -1, sale: 0 };
    let start = 0;
    let tab = 0;
    tab = tabDict[query.tab];

    if (!willReload && list) {
      start = list.length;
    }
    const options = {
      url: `${weibanhost}/api/sidebar/getOnlineUserMoneyByPhone`,
      method: 'GET',
      data: {
        ...query,
        start: start,
      },
    };
    const result = yield call(app.httpFetch, options);

    yield put(weibanOrderCompletion(result.error, result.data));
    if(result.error){
      app.redirectTo('/weiban/phone')
    }
  });
}


export function* weibanStoreOrderGet() {
  yield takeEvery('WEIBAN_STORE_ORDER', function* ({ willReload }) {
    const { list, query } = yield select(state => state.weiban.weibanstore);
    const tabDict = { store: -1, sale: 0 };
    let start = 0;
    let tab = 0;
    tab = tabDict[query.tab];
    if (!willReload && list) {
      start = list.length;
    }
    const options = {
      url: `${weibanhost}/api/sidebar/getOfflineUserMoneyByPhone`,
      method: 'GET',
      data: {
        ...query,
        start: start,
      },
    };
    const result = yield call(app.httpFetch, options);

    yield put(weibanStoreOrderCompletion(result.error, result.data));
  });
}
export function* weibanOrderDetailGet() {
  yield takeEvery('WEIBAN_ORDER_DETAIL', function* ({ query }) {
    const url = query.tab === 'store' ? `${weibanhost}/api/sidebar/offlineOrderInFo` : `${weibanhost}/api/sidebar/onlineOrderInFo`
    const options = {
      url: url,
      data: { ...query, billNo:query.orderId },
      method: 'GET'
    };
    const result = yield call(app.httpFetch, options);
    yield put(weibanOrderDetailCompletion(result.error, result.data));
  });
}

export default function* weibansSaga() {
  yield all([fork(weibanphonePost)]);
  yield all([fork(weibanOrderGet)]);
  yield all([fork(weibanStoreOrderGet)]);
  yield all([fork(weibanOrderDetailGet)]);
}
